export const UPDATE_USER_PASSWORD_URL = '/api/v1/user/update-password'
